import axios from 'axios';
import { useState, useMemo } from "react"
import { useNavigate } from 'react-router-dom';
import { clearPermissions, savePermissions } from "../auth/permissions";

export default function BackMethods() {
    const navigate = useNavigate();

    const governorates = [
        "دمشق", "ريف دمشق", "حلب", "حمص", "حماة", "اللاذقية", "طرطوس", "إدلب", "دير الزور", "الرقة", "الحسكة", "السويداء", "درعا", "القنيطرة"
    ];

    const UserTypes = [{ id: 1, name: "موبايل" }, { id: 2, name: "ويب" }];
    const serverUrl = 'https://custpro.gov.sy/api/';

    const getStoredItem = (key) => {
        const item = localStorage.getItem(key);
        try {
            return item ? JSON.parse(item) : null;
        } catch { return null; }
    };

    const [token, setToken] = useState(getStoredItem('token'));
    const [user, setUser] = useState(getStoredItem('user'));

    const getToken = () => getStoredItem('token');
    const getUser = () => getStoredItem('user');

    const getUserConstraints = () => {
        const currentUser = user;
        const gov = currentUser?.Governorate || currentUser?.governorate || "";
        const city = currentUser?.City || currentUser?.city || "";
        const sector = currentUser?.Sector || currentUser?.sector || "";
        const roleName = currentUser?.roleName || currentUser?.RoleName || "";

        return {
            userGovernorate: gov,
            userCity: city,
            userSector: sector,
            userId: currentUser?.userId || currentUser?.UserId || null,
            roleName,
            isSuperAdmin: roleName === "SuperAdmin" || !gov,
        };
    };

    const backEnd_request = useMemo(() => {
        const instance = axios.create({
            baseURL: serverUrl,
            headers: { 'Content-Type': 'application/json' }
        });

        instance.interceptors.request.use(
            (config) => {
                const currentToken = getToken();
                if (currentToken) {
                    config.headers.Authorization = `Bearer ${currentToken}`;
                }

                // تطبيق القيود على طلبات GET تلقائياً
                if (config.method === 'get') {
                    const constraints = getUserConstraints();

                    // طباعة للتشخيص (يمكنك حذفها لاحقاً)
                    // console.log("Current User Constraints:", constraints);
                    // طباعة للتشخيص (يمكنك حذفها لاحقاً)
                    // console.log("Current User Constraints:", user);

                    const extraParams = {};
                    // استخدام الحروف الكبيرة كما يطلب الـ Swagger في صورتك
                    if (constraints.userGovernorate) extraParams.Governorate = constraints.userGovernorate;
                    if (constraints.userCity) extraParams.City = constraints.userCity;

                    config.params = {
                        ...config.params,
                        ...extraParams
                    };

                    // console.log("Final Request URL:", config.url, "with params:", config.params);            
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // اعتراض الاستجابة للتوكن المنتهي
        instance.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config;
                if (error.response?.status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true;
                    try {
                        const rToken = getStoredItem('refreshToken');
                        const res = await axios.post(`${serverUrl}refresh`, { refresh_token: rToken });
                        const newToken = res.data.token;
                        localStorage.setItem('token', JSON.stringify(newToken));
                        setToken(newToken);
                        originalRequest.headers.Authorization = `Bearer ${newToken}`;
                        return instance(originalRequest);
                    } catch (err) {
                        logout();
                        return Promise.reject(err);
                    }
                }
                return Promise.reject(error);
            }
        );

        return instance;
    }, [token, user]); // تحديث الـ instance عند تغير المستخدم أو التوكن

    const saveToken = (data) => {
        localStorage.setItem('token', JSON.stringify(data.token));
        localStorage.setItem('user', JSON.stringify(data.user || {}));
        localStorage.setItem('refreshToken', JSON.stringify(data.refreshToken || null));
        savePermissions(data.user || {});
        setToken(data.token);
        setUser(data.user || {});
        navigate('/admin');
    };

    const logout = () => {
        localStorage.clear();
        clearPermissions();
        setToken(undefined);
        setUser(undefined);
        navigate('/admin/login');
    };

    const checkUserLogin = () => {
        if (!token) {
            navigate('/admin/login');
            return false;
        }
        return true;
    };

    return {
        governorates,
        UserTypes,
        setToken: saveToken,
        serverUrl,
        token,
        user,
        getToken,
        getUser,
        getUserConstraints,
        backEnd_request,
        logout,
        checkUserLogin,
    };
}